import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingRight: 30
  },

  padding: {
    paddingLeft: 30
  }
})

export default useStyles